import { useEffect } from 'react'
import { useRouter } from 'next/router'

export function useScrollToNewsletter(addiction: boolean) {
  const router = useRouter()

  useEffect(() => {
    if (!router.isReady) return
    if (!('newsletter' in router.query)) return
    if (!addiction) return

    const el = document.getElementById('newsletter')
    if (!el) return

    const header = document.querySelector<HTMLElement>('#header') // если есть фикс. хедер
    const offset = header?.offsetHeight ?? 0

    const scrollToEl = () => {
      const top = el.getBoundingClientRect().top + window.pageYOffset - offset
      window.scrollTo({ top, behavior: 'auto' })

      requestAnimationFrame(() => {
        const top2 = el.getBoundingClientRect().top + window.pageYOffset - offset
        window.scrollTo({ top: top2, behavior: 'auto' })
      })

      el.tabIndex = -1
      el.focus?.({ preventScroll: true })
      requestAnimationFrame(() => el.blur())
    }

    const pendingImgs = Array.from(document.images).filter((img) => !img.complete)
    if (pendingImgs.length) {
      let left = pendingImgs.length
      const onDone = () => {
        if (--left <= 0) scrollToEl()
      }
      pendingImgs.forEach((img) => img.addEventListener('load', onDone, { once: true }))
      setTimeout(scrollToEl, 1500)
    } else {
      requestAnimationFrame(() => requestAnimationFrame(scrollToEl))
    }

    const { newsletter, ...rest } = router.query
    router.replace({ pathname: router.pathname, query: rest }, undefined, { shallow: true }).then()
  }, [router.isReady, addiction])
}
